import { getUniqueId } from '../../unique-id/unique-id.service';
import { TrackConfig } from './tracker.slice';

export const getTrackName = (trackObj: string | object | TrackConfig | undefined | null): string =>
  (trackObj && (trackObj as TrackConfig).trackName) || trackObj?.toString() || '';

export const getUniqueTrackName = (
  trackObj: string | object | TrackConfig | undefined | null
): string => `${getTrackName(trackObj)}_${getUniqueId()}`;
